/* global require */
// Load floodgate override before binky initializes
require('../../polyfills/floodgate-override');

(function() {
  /*=== Bundle Dependecies ===*/
  angular.module('rcAngular', ['ngSanitize', 'ngAnimate', 'ui.router', 'tmh.dynamicLocale']);
  angular.module('rcServices', [
    'binky.core.api.jil',
    'binky.core.configuration.ready',
    'binky.core.download-utils',
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.translation-utils',
    'rcServices.settings',
    'rcServices.auth',
    'rcServices.user',
    'rcServices.customerSegments',
    'rcServices.customers',
    'rcServices.marketSegments',
    'rcServices.payload',
    'rcServices.customersNarrowDownOptions',
    'rcServices.domUtility',
    'rcServices.utility',
    'rcServices.selectedCustomer',
    'rcServices.customersListSnapshot',
    'rcServices.breadcrumbsMenu',
    'rcServices.sspList',
    'rcServices.paStatus',
    'rcServices.regionCodeToLang',
    'rcServices.modal',
    'rcServices.purchaseAuthorization',
    'rcServices.curtainNotifications',
    'rcServices.regions',
    'rcServices.imsClient',
    'rcServices.customerInvitation',
    'rcServices.resellerOrg',
    'rcServices.teamMembers',
    'rcServices.teamMemberStatus',
    'rcServices.httpInterceptor',
    'rcServices.redirector',
    'rcServices.rcUserRoles',
    'rcServices.preLoginRouterState',
    'rcServices.licenseAdminSearch',
    'rcServices.reseller',
    'rcServices.licenseAdminSearchSnapshot',
    'rcServices.customer',
    'rcServices.renewalOrder',
    'rcServices.licensingAdmins',
    'rcServices.resellers',
    'rcServices.resellerPreferredLanguages',
    'rcServices.resellerInvitation',
    'rcServices.resellerPlanTypes',
    'rcServices.defaultResponseTransformer',
    'rcServices.customersResponseTransformer',
    'rcServices.demoMode',
    'rcServices.miniJil',
    'rcServices.defaultProductsSorter',
    'rcServices.deviceLicensingEligibility',
    'rcServices.customerOrderHistoryConvertor',
    'rcServices.arrayToCsv',
    'rcServices.csvToArray',
    'rcServices.utfEncoder',
    'rcServices.sessionStorage',
    'rcServices.blackoutError',
    'rcServices.browserSupported',
    'rcServices.storageAvailable',
    'rcServices.customerLoyaltyPrograms',
    'rcServices.customerNotifications',
    'rcServices.productToProdName',
    'rcServices.licenseSummaryUtility',
    'rcServices.customerRenewalQuote',
    'rcServices.renewalQuoteUtility',
    'rcServices.customerLoyalty3yc',
    'rcServices.anniversaryDates'
  ]);
  angular.module('rcCommerce', [
    'rcCommerce.offer',
    'rcCommerce.offers',
    'rcCommerce.orders',
  ]);
  angular.module('rcEntities', [
    'rcEntities.customer',
    'rcEntities.product',
    'rcEntities.rcProductList',
    'rcEntities.consolidatedProduct',
    'rcEntities.rcConsumableList',
    'rcEntities.rcConsumableUsageList'
  ]);
  angular.module('rcControllers', [
    'app.core.products.usage',
    'rcControllers.login',
    'rcControllers.logout',
    'rcControllers.dashboard',
    'rcControllers.customers',
    'rcControllers.customerDetails',
    'rcControllers.orgainzationDetails',
    'rcControllers.teamMembers',
    'rcControllers.createPaModal',
    'rcControllers.addCustomerModal',
    'rcControllers.resellerChangeModal',
    'rcControllers.purchaseDetailsModal',
    'rcControllers.productsWithSameOrderNumberModal',
    'rcControllers.productsWithSamePurchaseAuthModal',
    'rcControllers.customerReminderModal',
    'rcControllers.newCancelPaModal',
    'rcControllers.cancelCustomerInvitationModal',
    'rcControllers.addTeamMembersModal',
    'rcControllers.removeTeamMemberModal',
    'rcControllers.footer',
    'rcControllers.selectTeamMemberModal',
    'rcControllers.licenseAdminSearch',
    'rcControllers.resellerImpersonator',
    'rcControllers.licenseAdmin',
    'rcControllers.changeCustomerReseller',
    'rcControllers.extendCustomerRenewalWindow',
    'rcControllers.licenseAdminBulkChangeResellerController',
    'rcControllers.licenseAdminBulkInviteResellerController',
    'rcControllers.manageLicensingAdmins',
    'rcControllers.licenseAdminInviteReseller',
    'rcControllers.resellerReminderModal',
    'rcControllers.demoMode',
    'rcControllers.alertModal',
    'rcControllers.yesNoModal',
    'rcControllers.loyaltyMembershipModal',
    'rcControllers.licenseDelegationDetailModal',
    'rcControllers.cookiesDisabled',
    'rcControllers.consumableUsageModal'
  ]);
  angular.module('rcFilters', [
    'rcFilters.regionCodeToLanguage',
    'rcFilters.address',
    'rcFilters.date',
    'rcFilters.personName',
    'rcFilters.arrayRange',
    'rcFilters.productToProductName',
    'rcFilters.numberFormatter',
    'rcFilters.licenseCountColumnValue',
    'rcFilters.currencyFormatter',
    'rcFilters.formatMonth',
    'rcFilters.anniversaryDate'
  ]);
  angular.module('rcDirectives', [
    'rcDirectives.pagination',
    'rcDirectives.sortableColumn',
    'rcDirectives.search',
    'rcDirectives.customerMiniProfile',
    'rcDirectives.date',
    'rcDirectives.rcDownloadCsv',
    'rcDirectives.marketSegmentIcon',
    'rcDirectives.planTypeIcon',
    'rcDirectives.addressForm',
    'rcDirectives.personForm',
    'rcDirectives.Pulldown',
    'rcDirectives.include',
    'rcDirectives.adobeidEmail',
    'rcDirectives.numbersOnly',
    'rcDirectives.rcFileReader'
  ]);
  angular.module('rcLocalization', [
    'binky.core.locale',
    'pascalprecht.translate',
    'rcLocalization.languages'
  ]);
})();
